import { createSlice } from '@reduxjs/toolkit'
import { filterByIncludes } from '../../Helpers/helpers';

const initialState = {
    mergeList: [],
    stats: {},
    currentChart: null,
    chartMachines: null,
    alerts: null,
    statsList: []
}

export const kpiSlice = createSlice({
    name: 'kpis',
    initialState,
    reducers: {
        setMergeList: (state, { payload }) => {
            let { mergeList } = payload;
            console.log({ payload })
            state.mergeList = mergeList
        },
        setMergeStat: (state, { payload }) => {
            let { stat, currentChart, chartMachines } = payload;
            state.stats = stat
            state.currentChart = currentChart
            state.chartMachines = chartMachines
        },
        changeChart: (state, { payload }) => {
            state.currentChart = payload
        },
        setAlerts: (state, { payload }) => {
            state.alerts = payload
        },
        updateStatTime: (state, { payload }) => {
            state.stats = { ...state?.stats, updated_at: payload }
        },
        updateShifts: (state, { payload }) => {
            state.shiftsData = payload
        },
        setStatsList: (state, { payload }) => {
            let { statsList } = payload;
            state.statsList = statsList
        }
    },
})

// Action creators are generated for each case reducer function
export const { setMergeList, setMergeStat, changeChart, setAlerts, updateStatTime, updateShifts, setStatsList } = kpiSlice.actions
export default kpiSlice.reducer
export const { stats } = (state) => state.kpis;
